import { Component } from 'react'
import { Provider } from 'mobx-react'

import * as h from 'h'

import UiStore from 'stores/UiStore'
import ExpertiseStore from 'stores/ExpertiseStore'
import ProjectStore from 'stores/ProjectStore'
import ResourceStore from 'stores/ResourceStore'
import StoryStore from 'stores/StoryStore'
import SearchStore from 'stores/SearchStore'
import AboutStore from 'stores/AboutStore'
import HuskyTalesStore from 'stores/HuskyTalesStore'

const stores = {
  UiStore,
  ExpertiseStore,
  ProjectStore,
  ResourceStore,
  StoryStore,
  SearchStore,
  AboutStore,
  HuskyTalesStore
}

export default class StoreProvider extends Component {
  render () {
    const { children } = this.props

    return h.h(Provider, stores, children)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/StoreProvider.js